import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import imageAlbumService from "../../service/image-album";
import { ImageAlbumItem, ImageAlbumState } from "../../@type/image-album";


export const getImageAlbum = createAsyncThunk(
    "get/getImageAlbum",
    async () => {
      const { data } = await imageAlbumService.get();
      return data;
    }
  );
  export const postImageAlbum = createAsyncThunk(
    "post/postImageAlbum",
    async (ImageAlbumData: ImageAlbumItem[]) => {
      const { data } = await imageAlbumService.post(ImageAlbumData);
      return data;
    }
  );
  export const deleteImageAlbum = createAsyncThunk(
  "delete/imageAlbum",
  async (id: number) => {
    await imageAlbumService.delete(id); // BE trả 204 / empty
    return id; // 🔥 BẮT BUỘC
  }
);

const initialState: ImageAlbumState = {
  imageAlbumList: [],
  imageAlbumDetail: {
    id:0,
    imgUrl:""
  }
};

const ImageAlbumSlice = createSlice({
  name: "ImageAlbum",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getImageAlbum.fulfilled, (state, action) => {
      state.imageAlbumList = action.payload;
    });
     builder.addCase(postImageAlbum.fulfilled, (state, action) => {
          state.imageAlbumList.push(action.payload);
        });
   builder.addCase(deleteImageAlbum.fulfilled, (state, action) => {
  state.imageAlbumList = state.imageAlbumList.filter(
    (item) => item.id !== action.payload
  );
});

  },
});

export default ImageAlbumSlice.reducer;
